import type { ReactNode } from 'react'
import Header from '@cloudscape-design/components/header'
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group'
import type { BreadcrumbGroupProps } from '@cloudscape-design/components/breadcrumb-group'
import Button from '@cloudscape-design/components/button'
import SpaceBetween from '@cloudscape-design/components/space-between'
import { useHelpPanelStore } from '@/state/helpPanelStore'

interface PageHeaderProps {
  title: string
  description?: string
  actions?: ReactNode
  breadcrumbs?: BreadcrumbGroupProps['items']
  hasHelp?: boolean
}

export default function PageHeader({ title, description, actions, breadcrumbs, hasHelp }: PageHeaderProps) {
  const toggle = useHelpPanelStore((state) => state.toggle)

  const finalActions = hasHelp || actions ? (
    <SpaceBetween direction="horizontal" size="xs">
      {hasHelp && (
        <Button
          iconName="status-info"
          variant="icon"
          onClick={() => toggle()}
          ariaLabel="Help"
        />
      )}
      {actions}
    </SpaceBetween>
  ) : undefined

  return (
    <SpaceBetween size="m">
      {breadcrumbs && <BreadcrumbGroup items={breadcrumbs} />}
      <Header
        variant="h1"
        description={description}
        actions={finalActions}
      >
        {title}
      </Header>
    </SpaceBetween>
  )
}
